import React from "react";
import { RouteProps } from "react-router-dom";

import {
  Login,
  EsqueciSenha,
  Home,
  DadosPessoais,
  Plano,
  Extrato,
  Resgate,
  Portabilidade,
  TrocarSenha,
  Relacionamento,
  Beneficios,
  Contracheques,
  ContrachequeDetalhe,
  Emprestimos,
  EmprestimosDetalhe,
  EmprestimosSimulador,
  EmprestimosSimuladorPrestacoes,
  ListarParticipantes,
  SelecionarMatricula,
  ComprovanteRendimentos,
  AlteracaoCadastral,
  EmprestimosSimuladorResumo,
  RendaMonitorada,
  SelecionarContrato
} from "./pages";
import { EmprestimosSimuladorToken } from "./pages/Emprestimos";

function GetRotas() {
  const rotas = [
    {
      titulo: "Login",
      caminho: "/login",
      componente: (routeProps: RouteProps) => <Login {...routeProps} />,
      mostrarMenu: false,
      exact: false,
    },
    {
      titulo: "Esqueci Minha Senha",
      caminho: "/esqueciSenha",
      componente: (routeProps: RouteProps) => (
        <EsqueciSenha {...routeProps} />
      ),
      mostrarMenu: false,
      exact: false,
    },
    {
      id: "home",
      titulo: "Home",
      icone: "fas fa-home",
      caminho: "/",
      componente: (routeProps: RouteProps) => <Home {...routeProps} />,
      mostrarMenu: true,
      exact: true,
    },
    {
      id: "dados",
      titulo: "Seus Dados",
      icone: "fas fa-user",
      caminho: "/dados",
      componente: (routeProps: RouteProps) => (
        <DadosPessoais {...routeProps} />
      ),
      mostrarMenu: true,
    },
    {
      id: "plano",
      titulo: "Seu Plano",
      icone: "fas fa-list",
      caminho: "/plano",
      componente: (routeProps: RouteProps) => <Plano {...routeProps} />,
      mostrarMenu: true,
    },
    {
      id: "extrato",
      titulo: "Extrato",
      caminho: "/extrato",
      componente: (routeProps: RouteProps) => <Extrato {...routeProps} />,
      mostrarMenu: false,
    },
    {
      id: "resgate",
      titulo: "Simulador de Resgate",
      caminho: "/resgate",
      componente: (routeProps: RouteProps) => <Resgate {...routeProps} />,
      mostrarMenu: false,
    },
    {
      id: "portabilidade",
      titulo: "Simulador de Portabilidade",
      caminho: "/portabilidade",
      componente: (routeProps: RouteProps) => (
        <Portabilidade {...routeProps} />
      ),
      mostrarMenu: false,
    },
    {
      id: "beneficios",
      titulo: "Seus Benefícios",
      icone: "fas fa-money-bill-alt",
      caminho: "/beneficios",
      componente: (routeProps: RouteProps) => (
        <Beneficios {...routeProps} />
      ),
      mostrarMenu: true,
      exact: true,
    },
    {
      titulo: "Comprovante IRRF",
      icone: "fas fa-list-alt",
      caminho: "/comprovanteIRRF",
      componente: (routeProps: RouteProps) => (
        <ComprovanteRendimentos {...routeProps} />
      ),
      mostrarMenu: true,
      exact: true,
      id: "comprovanteIRRF",
    },
    {
      titulo: "Demonstrativos de Pagamento - Contracheque",
      icone: "fas fa-closed-captioning",
      caminho: "/contracheques",
      caminhoLink: "/contracheques/",
      componente: (routeProps: RouteProps) => (
        <Contracheques {...routeProps} />
      ),
      mostrarMenu: false,
      exact: true,
    },
    {
      titulo: "Demonstrativos de Pagamento - Contracheque",
      icone: "fas fa-closed-captioning",
      caminho: "/contracheques/:sqProcesso/:dtReferencia",
      caminhoLink: "/contracheques/",
      componente: (routeProps: RouteProps) => (
        <ContrachequeDetalhe {...routeProps} />
      ),
      mostrarMenu: false,
    },
    {
      id: "emprestimos",
      titulo: "Empréstimos",
      icone: "fas fa-closed-captioning",
      caminho: "/emprestimos",
      componente: (routeProps: RouteProps) => (
        <Emprestimos {...routeProps} />
      ),
      mostrarMenu: true,
      exact: true,
    },
    {
      id: "emprestimosDetalhes",
      titulo: "Detalhes do Empréstimo",
      icone: "fas fa-closed-captioning",
      caminho: "/emprestimos/:sqContrato",
      caminhoLink: "/emprestimos/",
      componente: (routeProps: RouteProps) => (
        <EmprestimosDetalhe {...routeProps} />
      ),
      mostrarMenu: false,
    },
    {
      id: "emprestimosSimulador",
      titulo: "Simulação e Contratação de Empréstimos",
      icone: "fas fa-closed-captioning",
      caminho: "/emprestimosSimulador",
      componente: (routeProps: RouteProps) => (
        <EmprestimosSimulador {...routeProps} />
      ),
      mostrarMenu: false,
      exact: true,
    },
    {
      id: "emprestimosSimuladorPrestacoes",
      titulo: "Simulação e Contratação de Empréstimos",
      icone: "fas fa-closed-captioning",
      caminho: "/emprestimosSimuladorPrestacoes",
      componente: (routeProps: RouteProps) => (
        <EmprestimosSimuladorPrestacoes {...routeProps} />
      ),
      mostrarMenu: false,
      exact: true,
    },
    {
      id: "emprestimosSimuladorPrestacoes",
      titulo: "Simulação e Contratação de Empréstimos",
      icone: "fas fa-closed-captioning",
      caminho: "/emprestimosSimuladorResumo",
      componente: (routeProps: RouteProps) => (
        <EmprestimosSimuladorResumo {...routeProps} />
      ),
      mostrarMenu: false,
      exact: true,
    },
    {
      id: "emprestimosSimuladorToken",
      titulo: "Simulação e Contratação de Empréstimos",
      icone: "fas fa-closed-captioning",
      caminho: "/emprestimosSimuladorToken",
      componente: (routeProps: RouteProps) => (
        <EmprestimosSimuladorToken {...routeProps} />
      ),
      mostrarMenu: false,
      exact: true,
    },
    {
      id: "rendaMonitorada",
      titulo: "Renda Monitorada",
      icone: "fas fa-chart-line",
      caminho: "/rendaMonitorada",
      componente: (routeProps: RouteProps) => (
        <RendaMonitorada {...routeProps} />
      ),
      mostrarMenu: true,
    },
    {
      id: "trocarSenha",
      titulo: "Trocar senha",
      icone: "fas fa-lock",
      caminho: "/trocarSenha",
      componente: (routeProps: RouteProps) => (
        <TrocarSenha {...routeProps} />
      ),
      mostrarMenu: true,
    },
    {
      id: "relacionamento",
      titulo: "Relacionamento",
      icone: "fas fa-envelope",
      caminho: "/relacionamento",
      componente: (routeProps: RouteProps) => (
        <Relacionamento {...routeProps} />
      ),
      mostrarMenu: true,
    },
    {
      titulo: "Selecionar Matrícula",
      caminho: "/selecionarMatricula",
      componente: (routeProps: RouteProps) => (
        <SelecionarMatricula {...routeProps} />
      ),
      mostrarMenu: true,
      caminhoExato: true,
      id: "selecionarMatricula",
      icone: "fas fa-sync-alt",
    },
    {
      titulo: "Selecionar Contrato",
      caminho: "/selecionarContrato",
      componente: (routeProps: RouteProps) => (
        <SelecionarContrato {...routeProps} />
      ),
      mostrarMenu: true,
      caminhoExato: true,
      id: "selecionarContrato",
      icone: "fas fa-sync-alt",
    },
    {
      titulo: "Listar Participantes",
      caminho: "/listarParticipantes",
      componente: (routeProps: RouteProps) => (
        <ListarParticipantes {...routeProps} />
      ),
      mostrarMenu: false,
      exact: false,
      id: "listarParticipantes",
    },
    {
      titulo: "Alteração Cadastral",
      caminho: "/alteracaocadastral",
      icone: "fas fa-sync-alt",
      componente: (routeProps: RouteProps) => <AlteracaoCadastral {...routeProps} />,
      mostrarMenu: true,
      caminhoExato: false,
      id: "alteracaocadastral"
    }
  ];

  return rotas;
}

export default GetRotas();
